/* eslint-disable */
<div style="max-width:403px;max-height:300px" id="container123"></div>
<template>
    <section class="section section-white content-padded" onload="init()">
        <el-form ref="form" :model="form" label-width="110px">
            <el-form-item label="主播名称">
                <el-select v-model="form.anchor_nickname" filterable placeholder="请选择" remote :remote-method="getAnchorList" @change="handleAnchorChange">
                    <el-option
                            v-for="item in anchorList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    >
                    </el-option>
                </el-select>
                <div v-show="false">
                    <el-col ><el-input v-model="form.anchor_id" placeholder=""></el-input></el-col>
                </div>
            </el-form-item>
            <el-form-item label="店铺">
                <el-select v-model="form.distributor_name" filterable placeholder="请选择" remote :remote-method="getDistributorList" @change="handleDistibutorChange">
                    <el-option
                            v-for="item in distributorList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    >
                    </el-option>
                </el-select>
                <div v-show="false">
                    <el-col ><el-input v-model="form.inca_id" placeholder=""></el-input></el-col>
                </div>
            </el-form-item>
            <el-form-item label="直播标题">
                <el-input v-model="form.title" placeholder="直播标题" style="width: 55%;"></el-input>
            </el-form-item>
            <el-form-item label="直播简介">
                <el-input v-model="form.description" placeholder="直播简介" style="width: 55%;"></el-input>
            </el-form-item>
            <el-form-item label="直播间封面图片">
                <el-input v-model="form.cover_image" style="width: 55%;"></el-input>
            </el-form-item>
            <!--<el-form-item label="直播选品">-->
                <!--<el-input v-model="form.item_bn" style="width: 55%;"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item label="视频类型" prop="source_video_type">
                <el-select v-model="form.source_video_type_text"  placeholder="视频类型" @change="handleVideoTypeChange">
                    <el-option  v-for="item in sourceVideoTypeOption" :key="item.key" :label="item.name" :value="item.name" >
                    </el-option>
                </el-select>
                <div v-show="false">
                    <el-col ><el-input v-model="form.source_video_type" placeholder=""></el-input></el-col>
                </div>
            </el-form-item>
            <el-form-item label="视频回放地址">
                <el-input v-model="form.source_video_url" style="width: 55%;"></el-input>
            </el-form-item>
            <el-form-item label="是否允许录播">
                <el-switch v-model="form.is_record" active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
            </el-form-item>
            <div class="section-footer with-border content-center">
                <el-button size="large" @click="cancelSubmit">取消</el-button>
                <el-button type="primary" @click="submitItemsActionConfirm" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
            </div>
        </el-form>
    </section>
</template>
<script>
    import { getDistributorList } from '../../api/marketing'
    import {
        saveLive as saveForm,
        getLiveDetail as getDetail,
        getAnchorList,
    } from '../../api/live'

    export default {
        data () {
            return {
                distributorList:[],
                anchorList:[],
                submitLoading: false,
                form: {
                    anchor_id:'',
                    anchor_name:'',
                    anchor_nickname:'',
                    cover_image:'',
                    description:'',
                    end_at:'',
                    inca_id:'',
                    is_record:'true',
                    item_bn:'',
                    live_id:'',
                    source_video_type:'',
                    source_video_url:'',
                    title:'',
                    source_video_type_text:'',
                    distributor_name:'',
                },
                sourceVideoTypeOption: [
                    {name: "直播", value: 'live'},
                    {name: "上传视频", value: 'upload'},
                ],
            }
        },
        methods: {
            cancelSubmit () {
                this.$router.go(-1)
                // this.$router.push({ path: this.matchInternalRoute('livelist'),query:{}})
            },
            submitItemsActionConfirm () {
                this.submitLoading = true
                saveForm(this.form).then(res => {
                    this.submitLoading = false
                    this.$message({ type: 'success', message: '保存成功'})
                    if (this.$store.getters.login_type != 'distributor') {
                        this.$router.go(-1)
                    }
                }).catch (error => {
                    this.submitLoading = false
                })
            },
            getDistributorList(val){
                getDistributorList({page: 1, pageSize: 50,name:val}).then(res => {
                    this.distributorList = [];
                    for (let item of res.data.data.list) {
                        this.distributorList.push({name: item.name, id: item.number})
                    }
                })
            },
            handleDistibutorChange:function (val){
                this.form.inca_id = val
            },
            getAnchorList(val){
                getAnchorList({page: 1, pageSize: 50,name:val}).then(res => {
                    this.anchorList = [];
                    for (let item of res.data.data.list) {
                        this.anchorList.push({name: item.nickname, id: item.anchor_id})
                    }
                })
            },
            handleAnchorChange:function (val){
                this.form.anchor_id = val
            },
            handleVideoTypeChange:function (val){
                this.form.source_video_type = val
            },
        },
        mounted () {
            var that = this
            this.anchor_id = this.$route.params.id
            getDetail(this.$route.params).then(res => {
                if(res.data.data){
                    if(this.anchor_id){
                        this.is_new = false;
                    }
                    that.sourceVideoTypeOption.forEach((v,k)=>{
                        if(v.value == res.data.data.source_video_type){
                            res.data.data.source_video_type_text = v.name
                        }
                    });
                    res.data.data.is_record = res.data.data.is_record ?  '1' : '0';
                    that.form = res.data.data
                }
            });
            this.getDistributorList()
            this.getAnchorList()
        }

    }
</script>

<style lang="scss">
    .bm-view {
        width: 100%;
        height: 300px;
    }
    #qqmap_rslist {
        border-right: 1px solid #e7e7eb;
    }
    #qqmap_container{
        float:left;
        width:800px;
        height:400px;
    }
    .checkbox {
        background-color: white;
        border-radius: 0px;
        border: 1px solid #d3d3d3;
        width: 20px;
        height: 20px;
        display: inline-block;
        text-align: center;
        vertical-align: bottom;
        line-height: 20px;
    }
</style>



// WEBPACK FOOTER //
// add.vue?3160eb4d